module.exports = __webpack_public_path__ + "static/media/cpaCharge.beaec792.png";